// Keeps the buy area in sync with the selected variant across three states:
// available (normal add to cart), preorder (oversold but still sellable) and
// unavailable (notify-me email capture). The theme reverts the button label to
// "add to cart" on every variant change, so this runs off the variantChange
// event published at the very end of that update.
class PreorderForm extends HTMLElement {
  connectedCallback() {
    this.purchase = this.querySelector('[data-preorder-purchase]');
    this.notify = this.querySelector('[data-preorder-notify]');
    this.etaLine = this.querySelector('[data-preorder-eta]');
    this.etaProperty = this.querySelector('[data-preorder-property]');
    this.submitLabel = this.querySelector('[name="add"] > span');
    this.notifyMe = this.querySelector('notify-me');
    this.variantStates = this.parseVariantStates();

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== this.dataset.sectionId) return;
      this.update(event.data.variant.id);
    });
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber?.();
  }

  parseVariantStates() {
    const source = this.querySelector('[data-preorder-variants]');
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.warn('[preorder] Could not parse variant states', error);
      return {};
    }
  }

  update(variantId) {
    // An unmapped variant means the state map is incomplete, so leave the
    // theme's own sold-out handling in place rather than guessing.
    const state = this.variantStates[variantId];
    if (!state) return;

    const isPreorder = state === 'preorder';
    const isUnavailable = state === 'unavailable';

    if (this.notifyMe) this.notifyMe.dataset.variant = variantId;

    if (this.notify) {
      this.notify.hidden = !isUnavailable;
      this.purchase.hidden = isUnavailable;
    }

    // Relevant for both preorder and notify; only a genuinely in-stock variant hides it.
    if (this.etaLine) this.etaLine.hidden = state === 'available';

    // Disabled inputs are left out of the submitted form data, so the ETA only
    // rides along on line items that are genuinely preorders.
    if (this.etaProperty) this.etaProperty.disabled = !isPreorder;

    if (this.submitLabel && !isUnavailable) {
      this.submitLabel.textContent = isPreorder
        ? this.dataset.preorderLabel
        : this.dataset.addToCartLabel;
    }
  }
}

customElements.define('preorder-form', PreorderForm);
